import template from './creditor.html';
import controller from './creditor.controller';

let creditorComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default creditorComponent;
